import _extends from "@babel/runtime/helpers/extends";
import React, { createContext, useState, lazy, Suspense, useMemo, useCallback } from 'react';
const AKInvitePeopleModal = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "async-invite-people-modal" */'./InvitePeopleModal'));
const AKModalTransition = /*#__PURE__*/lazy(() => import( /* webpackChunkName: "async-people-menu-modal-transition-dialog" */'@atlaskit/modal-dialog').then(module => ({
  default: module.ModalTransition
})));
export const InvitePeopleModalContext = /*#__PURE__*/createContext({
  isOpen: false,
  openModal: () => undefined,
  closeModal: () => undefined
});
export const InvitePeopleModalContextProvider = invitePeopleModalContextProviderProps => {
  const {
    children
  } = invitePeopleModalContextProviderProps;
  const [invitePeopleState, setInvitePeopleState] = useState({
    isOpen: false
  });
  const openModal = (invitePeopleProps, onClose) => {
    setInvitePeopleState({
      isOpen: true,
      props: invitePeopleProps,
      onClose
    });
  };
  const closeModal = useCallback(() => {
    var _invitePeopleState$on;
    if (!invitePeopleState.isOpen) {
      return;
    }
    (_invitePeopleState$on = invitePeopleState.onClose) === null || _invitePeopleState$on === void 0 ? void 0 : _invitePeopleState$on.call(invitePeopleState);
    setInvitePeopleState({
      previousProps: invitePeopleState.props,
      isOpen: false
    });
  }, [invitePeopleState]);
  const reopenModal = useCallback(() => {
    // Reopen function can only reopen invite people if openModal has been called once with props
    setInvitePeopleState(prevState => !prevState.isOpen && prevState.previousProps ? {
      props: prevState.previousProps,
      isOpen: true
    } : prevState);
  }, []);
  const context = useMemo(() => ({
    openModal,
    closeModal,
    isOpen: invitePeopleState.isOpen
  }), [closeModal, invitePeopleState.isOpen]);
  return /*#__PURE__*/React.createElement(InvitePeopleModalContext.Provider, {
    value: context
  }, children, invitePeopleState.isOpen && /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(AKModalTransition, null, /*#__PURE__*/React.createElement(AKInvitePeopleModal, _extends({
    onCloseHandler: closeModal,
    experimental_onReopenHandler: reopenModal
  }, invitePeopleState.props)))));
};